<nz-card class="condensed-card">
    <div class="card-header">
        <h2 style="font-weight: bold; font-size: 15px;">
            Inline{{is2D() ? '' : " : " + jobState.inline()}}

            @if(is2D && jobState.selectedModel() == 'grad' && jobState.selectedShot()){
                [Shot: {{jobState.selectedShot()}}]
            }
            @if(jobState.selectedLog(); as data){
            [{{data.name}}]
            }
        </h2>

        <div style="display: flex; gap: 10px; align-items: center;">
            <div class="omit-from-screenshot">
                @if(jobState.previouslySelectedModel(); as model){
                    <button nz-button class="expandable-button" nzSize="small" (click)="backToPreviousModel()">
                        <nz-icon nzType="arrow-left" nzTheme="outline" style="font-size: 10px; color: #aaa;" />
    
                        <span class="expand-container">
                            <span class="prefix-text">Go back to&nbsp;</span>
                        </span>
                        
                        <b class="concise">{{ model }}</b>
                    </button>
                }
            </div>
            <div class="omit-from-screenshot" style="display: flex; align-items: center; gap: 10px;">
                <a (click)="resetZoom()" nz-tooltip nzTooltipTitle="Reset Zoom" style="font-size: 20px;">
                    <nz-icon nzType="sync" nzTheme="outline" />
                </a>
                <button nz-button nzType="default" nzSize="small" class="settings-btn"
                    nz-dropdown [nzDropdownMenu]="inlineMenu" [nzClickHide]="false" nzTrigger="click">
                    <nz-icon nzType="setting" nzTheme="outline" />
                    <nz-icon class="settings-caret" nzType="down" nzTheme="outline" />
                </button>
            </div>
        </div>
    </div>

    <div class="slice-viewer">
        @if (sliceResource.isLoading()) {
        <div class="overlay">
            <nz-spin nzSimple nzTip="Fetching Seismic Slice..." nzSize="large"></nz-spin>
        </div>
        }
        @if (sliceResource.error(); as error) {
        <div class="slice-error">
            <nz-alert nzType="error" nzMessage="Error loading slice" [nzDescription]="error.message" nzShowIcon/>
        </div>
        }
        @if (displayData(); as data) {
        <div>
            <app-my-viewer 
                #sliceViewer [sliceImage]="data.sliceImage" [sliceArray]="data.sliceArray" 
                [colorbar]="data.colorbar" 
                [limits]="viewerSettings.inlineMinMax()" [horizonDataResource]="horizonsDataResource"
                [sonicDataResource]="sonicLogDataResource" [xIndicator]="jobState.crossline()"
                [yIndicator]="jobState.depth()" xLabel="Crossline" yLabel="Depth"
                [viewerHeight]="viewerSettings.viewerHeight()"
                [xCrop]="xCrop()"
                [yCrop]="yCrop()"
            >
            </app-my-viewer>
        </div>
        }
    </div>
</nz-card>


<nz-dropdown-menu #inlineMenu="nzDropdownMenu">
    <ul class="settings-dropdown" nz-menu [nzSelectable]="false">
        <li nz-submenu nzPlacement="bottomRight" nzTitle="Model Property" (nzOpenChange)="onModelPropertyOpenChange($event)">
            <ul>
                <li class="custom-menu-item" style="padding-bottom: 0;">
                    <input #modelSearchInput nz-input placeholder="Search Model Properties..." [ngModel]="propertySearch()"
                        (ngModelChange)="propertySearch.set($event)" (click)="$event.stopPropagation()"
                        (keydown)="onPropertySearchKeydown($event)" />
                </li>
                <li style="padding: 0;">
                    <ul class="scrollable-menu">
                        @if (jobState.availableModelsResource.isLoading()) {
                        <li nz-menu-item nzDisabled>
                            <span nz-icon nzType="loading" nzSpin></span>
                            Loading...
                        </li>
                        }@else if (jobState.availableModelsResource.error()) {
                        <li nz-menu-item nzDanger>There was an error fetching model types.</li>
                        }@else {
                            @if ((jobState.availableModelsResource.value() ?? []).length === 0) {
                            <li nz-menu-item nzDisabled>No models found.</li>
                            }@else {
                                @for (model of (jobState.availableModelsResource.value() ?? []) | searchableInputList:propertySearch(); track model; let i = $index) {
                                <li nz-menu-item #modelItem
                                    [nzSelected]="jobState.selectedModel() === model"
                                    [class.keyboard-highlighted]="highlightedModelIndex() === i"
                                    (click)="onSelectModelHandler(model)"
                                    (mouseenter)="highlightedModelIndex.set(i)">
                                    {{model}}
                                </li>
                                }
                            }
                        }
                    </ul>
                </li>
            </ul>
        </li>
        @if (!jobState.jobData().modelGrid.is2d){
        <li nz-menu-item class="custom-menu-item">Show Depth Slice
            <nz-switch [(ngModel)]="viewerSettings.showDepthSlice" />
        </li>
        }
        <li nz-menu-item class="custom-menu-item">
            <div style="display: flex; flex-direction: column; gap: 8px; width: 100%;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span>Vertical Profile</span>
                    <span style="font-size: 11px; color: #999;">3 options</span>
                </div>
                <nz-radio-group [(ngModel)]="viewerSettings.verticalProfileMode" style="width: 100%;">
                    <label nz-radio-button nzValue="show" style="flex: 1; text-align: center;">Show</label>
                    <label nz-radio-button nzValue="hide" style="flex: 1; text-align: center;">Hide</label>
                    <label nz-radio-button [nzDisabled]="viewerSettings.fullWidthIlXl()" nzValue="besideInline" style="flex: 1; text-align: center;">Show beside inline</label>
                </nz-radio-group>
            </div>
        </li>
        <li nz-menu-item class="custom-menu-item">
            Height
            <div style="width: 100px;">
                <nz-slider [(ngModel)]="viewerSettings.viewerHeight" [nzMin]="150" [nzMax]="900"
                    [nzStep]="25"></nz-slider>
            </div>
        </li>
        <li nz-menu-item (click)="openMinMaxDialog()" class="custom-menu-item">
            <div style="flex: 1; display: flex; justify-content: space-between; align-items: center;">
                Min/Max 
                <nz-icon style="color: #aaa;" nzType="export" nzTheme="outline" />
            </div>
        </li>
        <li nz-submenu nzTitle="Color Map" (nzOpenChange)="onColorPropertyOpenChange($event)">
            <ul>
                <li class="custom-menu-item" style="padding-bottom: 0;">
                    <input #colorMapInput nz-input placeholder="Search Color Maps..." [ngModel]="colorMapSearch()"
                        (ngModelChange)="colorMapSearch.set($event)" (click)="$event.stopPropagation()"
                        (keydown)="onColorMapSearchKeydown($event)" />
                </li>
                <li style="padding: 0;">
                    <ul class="scrollable-menu">
                        @if(jobState.colorMapResource.isLoading()){
                        <li nz-menu-item nzDisabled>
                            <span nz-icon nzType="loading" nzSpin></span>
                            Loading...
                        </li>
                        }@else if (jobState.colorMapResource.error(); as error) {
                        <li nz-menu-item nzDisabled nzDanger>
                            Unexpected error: {{error}}
                        </li>
                        }@else {
                        @for (cmap of (jobState.colorMapResource.value() ?? []) | searchableInputList:colorMapSearch(); track cmap) {
                        <li nz-menu-item #colorMapItem 
                            [nzSelected]="jobState.selectedCmap() === cmap" 
                            [class.keyboard-highlighted]="highlightedColorMapIndex() === $index" 
                            (click)="onSelectCmapHandler(cmap)" 
                            (mouseenter)="highlightedColorMapIndex.set($index)">
                            {{cmap}}
                        </li>
                        }
                        }
                    </ul>
                </li>
            </ul>
        </li>
        <li nz-menu-divider></li>
        <li nz-submenu nzTitle="Sonic Logs">
            <ul class="scrollable-menu">
                <li nz-menu-item class="custom-menu-item">Show Well Markers
                    <nz-switch [(ngModel)]="viewerSettings.showWellMarkers" />
                </li>
                <li nz-menu-item class="custom-menu-item">Show Sonic Log
                    <nz-switch [(ngModel)]="viewerSettings.showSonicLog" />
                </li>
                <li nz-menu-item class="custom-menu-item">Show Sample Points
                    <nz-switch [(ngModel)]="viewerSettings.showSonicSamples" />
                </li>
                <li class="custom-menu-item" style="padding-top: 10px;">
                    <nz-form-item class="floating-label" style="margin: 0;">
                        <nz-form-label>Frequency</nz-form-label>
                        <nz-input-number [nzDisabled]="!jobState.selectedLog()" (change)="sonicFrequencyChange($event)" [nzMin]="0" type="number" [(ngModel)]="sonicFrequeny" style="width: 100%; margin: 0 5px" />
                    </nz-form-item>
                </li>
                <li nz-menu-divider></li>
                @for (wellLog of wellLogs(); track wellLog.id ) {
                <li nz-menu-item (click)="onSelectWellLogHandler(wellLog)"
                    [nzSelected]="jobState.selectedLog()?.id === wellLog.id">
                    {{wellLog.name}}
                    <div style="font-size: 10px; color: #aaa;">IL: {{wellLog.inline}} | XL: {{wellLog.crossline}}
                    </div>
                </li>
                }
            </ul>
        </li>
        <li nz-submenu nzTitle="Horizons">
            <ul class="scrollable-menu">
                @if(jobState.horizonsResource.isLoading()){
                <li nz-menu-item nzDisabled>
                    <span nz-icon nzType="loading" nzSpin></span>
                    Loading...
                </li>
                }@else {
                @if (jobState.horizonsResource.error(); as error){
                <li nz-menu-item>Error getting horizons: {{error}}</li>
                }@else{
                    @if(jobState.horizonsResource.value().jobHorizons.length > 0){
                        <li nz-menu-group nzTitle="Job Horizons"></li>
                        @for(horizon of jobState.horizonsResource.value().jobHorizons; track horizon){
                            <li class="ant-dropdown-menu-item" [class.ant-dropdown-menu-item-selected]="selectedHorizonIds().has(horizon.id)"
                                (click)="onSelectHorizonHandler(horizon)"
                            ><span class="ant-menu-title-content">{{horizon.name}}</span></li>
                        }
                        <li nz-menu-divider ></li>
                    }
                    @if(jobState.horizonsResource.value().projectHorizons.length > 0){
                        <li nz-menu-group nzTitle="Project Horizons"></li>
                        @for(horizon of jobState.horizonsResource.value().projectHorizons; track horizon){
                            <li class="ant-dropdown-menu-item" [class.ant-dropdown-menu-item-selected]="selectedHorizonIds().has(horizon.id)"
                                (click)="onSelectHorizonHandler(horizon)">
                                <span class="ant-menu-title-content">{{horizon.name}}
                                    <div style="font-size: 10px; color: #aaa;">{{horizon.description}}</div>
                                </span>
                            </li>
                        }
                    }

                }
                }
            </ul>
        </li>

        @if(!availableIterationShots.isLoading() && !availableIterationShots.error()){
           <li nz-submenu nzTitle="Shots">
            <ul class="scrollable-menu">
                @for(shot of availableIterationShots.value(); track shot){
                    <li nz-menu-item (click)="onSelectShotHandler(shot)" [nzSelected]="shot == jobState.selectedShot()">Shot ID: <b>{{shot}}</b></li>
                }
            </ul>
           </li>
        }

        <li nz-menu-divider></li>

        <li nz-menu-item class="custom-menu-item">
            Dotted Line
            <nz-switch [(ngModel)]="viewerSettings.gridLines" />
        </li>
        <li nz-menu-item class="custom-menu-item">Smoothing
            <nz-switch [(ngModel)]="viewerSettings.smoothing" />
        </li>
        @if (!jobState.jobData().modelGrid.is2d){
        <li nz-menu-item class="custom-menu-item">Full Width IL/XL
            <nz-switch [(ngModel)]="viewerSettings.fullWidthIlXl" (ngModelChange)="setFullWidth($event)"/>
        </li>
        }

        <li nz-menu-divider></li>

        <li nz-submenu nzTitle="Screenshot" (click)="onScreenshot.emit()">
            <ul>
                <li nz-menu-group nzTitle="View"></li>
                <li nz-menu-item class="custom-menu-item"
                    [nzDisabled]="viewerSettings.verticalProfileMode() === 'hide'"
                    nz-tooltip [nzTooltipTitle]="viewerSettings.verticalProfileMode() === 'hide' ? 'Vertical profile is hidden — show it to include it in the screenshot' : null">
                    With Vertical Profile <nz-switch [(ngModel)]="viewerSettings.screenshotSettings.withVP"
                        [nzDisabled]="viewerSettings.verticalProfileMode() === 'hide'" />
                </li>
                @if (!jobState.jobData().modelGrid.is2d){
                <li nz-menu-item class="custom-menu-item">
                    With Depth Slice <nz-switch [(ngModel)]="viewerSettings.screenshotSettings.withDepth" />
                </li>
                }

                <li nz-menu-divider ></li>
                <li nz-menu-group nzTitle="Frame"></li>
                <li nz-menu-item class="custom-menu-item frame-menu-item">
                    <app-screenshot-frame-settings />
                </li>

                <li nz-menu-divider ></li>
                <li nz-menu-group nzTitle="Slices"></li>

                <li nz-menu-item class="custom-menu-item" (click)="onScreenshot.emit('Inline')">
                    <div style="flex: 1; display: flex; justify-content: space-between; align-items: center;">
                        Inline Slice
                        <nz-icon style="color: #aaa;" nzType="expand" nzTheme="outline" />
                    </div>
                </li>
                @if (!jobState.jobData().modelGrid.is2d){
                <li nz-menu-item class="custom-menu-item" (click)="onScreenshot.emit('Crossline')">
                    <div style="flex: 1; display: flex; justify-content: space-between; align-items: center;">
                        Crossline Slice
                        <nz-icon style="color: #aaa;" nzType="expand" nzTheme="outline" />
                    </div>
                </li>
                <!-- always rendered (disabled while hidden) so toggling "With Depth Slice" above,
                     which also shows the depth slice, doesn't resize the submenu under the mouse -->
                <li nz-menu-item class="custom-menu-item" [nzDisabled]="!viewerSettings.showDepthSlice()"
                    (click)="viewerSettings.showDepthSlice() && onScreenshot.emit('Depth')"
                    nz-tooltip [nzTooltipTitle]="viewerSettings.showDepthSlice() ? null : 'Show the depth slice to screenshot it'">
                    <div style="flex: 1; display: flex; justify-content: space-between; align-items: center;">
                        Depth Slice
                        <nz-icon style="color: #aaa;" nzType="expand" nzTheme="outline" />
                    </div>
                </li>
                }
            </ul>
        </li>

        <li nz-menu-divider></li>
        <li nz-menu-item class="custom-menu-item">
            <div>
                <b>Start ({{ rangeUnit() }})</b>
                <div style="display: flex; margin-top:5px; gap: 5px">
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1">
                        <nz-form-label [nzNoColon]="true">XL</nz-form-label>
                        <nz-input-number (change)="setRange($event, jobState.rangesStart.XL, 0)" [nzMin]="0" type="number"
                            [nzMax]="toRangeUnit(jobState.rangesEnd.XL() - 100)" nzSize="small" [ngModel]="toRangeUnit(jobState.rangesStart.XL())" />
                    </nz-form-item>
                    @if (!jobState.jobData().modelGrid.is2d){
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1">
                        <nz-form-label [nzNoColon]="true">IL</nz-form-label>
                        <nz-input-number (change)="setRange($event, jobState.rangesStart.IL, 0)" [nzMin]="0" type="number"
                            [nzMax]="toRangeUnit(jobState.rangesEnd.IL() - 100)" nzSize="small" [ngModel]="toRangeUnit(jobState.rangesStart.IL())" />
                    </nz-form-item>
                    }
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1">
                        <nz-form-label [nzNoColon]="true">Depth</nz-form-label>
                        <nz-input-number (change)="setRange($event, jobState.rangesStart.depth, 0)" [nzMin]="0" type="number"
                            [nzMax]="toRangeUnit(jobState.rangesEnd.depth() - 100)" nzSize="small" [ngModel]="toRangeUnit(jobState.rangesStart.depth())" />
                    </nz-form-item>
                </div>
            </div>
        </li>
        <li nz-menu-item class="custom-menu-item">
            <div>
                <b>End ({{ rangeUnit() }})</b>
                <div style="display: flex; margin-top:5px; gap: 5px">
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1;">
                        <nz-form-label [nzNoColon]="true">XL</nz-form-label>
                        <nz-input-number (change)="setRange($event, jobState.rangesEnd.XL, crosslineMax())"
                            [nzMin]="toRangeUnit(jobState.rangesStart.XL() + 100)" nzSize="small" [nzMax]="toRangeUnit(crosslineMax())" type="number" [ngModel]="toRangeUnit(jobState.rangesEnd.XL())" />
                    </nz-form-item>
                    @if (!jobState.jobData().modelGrid.is2d){
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1;">
                        <nz-form-label [nzNoColon]="true">IL</nz-form-label>
                        <nz-input-number (change)="setRange($event, jobState.rangesEnd.IL, inlineMax())"
                            [nzMin]="toRangeUnit(jobState.rangesStart.IL() + 100)" nzSize="small" [nzMax]="toRangeUnit(inlineMax())" type="number" [ngModel]="toRangeUnit(jobState.rangesEnd.IL())" />
                    </nz-form-item>
                    }
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1;">
                        <nz-form-label [nzNoColon]="true">Depth</nz-form-label>
                        <nz-input-number (change)="setRange($event, jobState.rangesEnd.depth, depthMax())"
                            [nzMin]="toRangeUnit(jobState.rangesStart.depth() + 100)" nzSize="small" [nzMax]="toRangeUnit(depthMax())" type="number" [ngModel]="toRangeUnit(jobState.rangesEnd.depth())" />
                    </nz-form-item>
                </div>
            </div>
        </li>
        @if (jobState.selectedModel() === 'Total_Vp_Update') {
        <li nz-menu-divider></li>
        <li nz-menu-item class="custom-menu-item">
            <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
                <nz-form-item class="floating-label" style="margin: 0; flex: 1;">
                    <nz-form-label>Iter</nz-form-label>
                    <nz-input-number nzSize="small" style="width: 100%;" [nzMax]="jobState.iteration()"
                        [nzMin]="0" [ngModel]="jobState.vpRef()"
                        [nzDisabled]="jobState.blockRef()"
                        (change)="setVpRef($event)"
                        (keydown.enter)="setVpRef($event)"
                    />
                </nz-form-item>
                <label nz-checkbox [(ngModel)]="jobState.blockRef">Block</label>
            </div>
        </li>
        <li nz-menu-divider></li>
        }
        @if (jobState.selectedModel() === 'DenChange AGC' || jobState.selectedModel() === "Density plus DenChange Reflectivity AGC") {
        <li nz-menu-divider></li>
        <li nz-menu-item class="custom-menu-item">
            <nz-form-item class="floating-label" style="margin: 0; width: 100%;">
                <nz-form-label>Window</nz-form-label>
                <nz-input-number nzSize="small" style="width: 100%;"
                    [nzMax]="jobState.jobData().modelGrid.nx3"
                    [nzMin]="1"
                    [ngModel]="jobState.AGCWindow()"
                    (change)="setAGCWindow($event)"
                    (keydown.enter)="setAGCWindow($event)"
                    [nzPrecision]="0"
                    [nzStep]="1"
                />
            </nz-form-item>
        </li>
        <li nz-menu-divider></li>
        }
        <li nz-menu-item class="custom-menu-item" (click)="jobState.resetRanges()">
            Reset Ranges
        </li>
        <li nz-menu-item class="custom-menu-item">
            Force Preserve Ranges
            <nz-switch [(ngModel)]="jobState.preserveRanges" />
        </li>

        <li nz-menu-divider></li>
        <li nz-menu-item class="custom-menu-item">
            <div style="flex-grow: 1;">
                <b style="display: block;">Axis Units <nz-icon nzType="info-circle" style="color: #aaa;" nzTheme="outline" nz-tooltip nzTooltipTitle="Toggling this only changes the axis labels. All relevant calculation will remain in meters"/></b>
                <nz-radio-group [(ngModel)]="viewerSettings.axisUnits" style="width: 100%; display: flex;">
                    <label nz-radio-button nzValue="km" style="flex:1; text-align: center;">kilometers (km)</label>
                    <label nz-radio-button nzValue="kft" style="flex:1; text-align: center;">kilofeet (kft)</label>
                </nz-radio-group>
            </div>
        </li>

        <li nz-menu-divider></li>
        <li nz-menu-item class="custom-menu-item">
            <div style="width: 100%;">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <b>Variable dx ({{ rangeUnit() }})</b>
                    <nz-switch [ngModel]="jobState.variableDx()" (ngModelChange)="jobState.setVariableDx($event)" />
                </div>
                <div style="display: flex; margin-top:10px; gap: 5px">
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1">
                        <nz-form-label [nzNoColon]="true">dx1</nz-form-label>
                        <nz-input-number nzSize="small" [nzMin]="0.01" [nzDisabled]="!jobState.variableDx()"
                            [ngModel]="toRangeUnit(jobState.dx1())" [ngModelOptions]="{ updateOn: 'blur' }"
                            (ngModelChange)="setDx('dx1', $event)" (keydown.enter)="$any($event.target).blur()" />
                    </nz-form-item>
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1">
                        <nz-form-label [nzNoColon]="true">dx2</nz-form-label>
                        <nz-input-number nzSize="small" [nzMin]="0.01" [nzDisabled]="!jobState.variableDx()"
                            [ngModel]="toRangeUnit(jobState.dx2())" [ngModelOptions]="{ updateOn: 'blur' }"
                            (ngModelChange)="setDx('dx2', $event)" (keydown.enter)="$any($event.target).blur()" />
                    </nz-form-item>
                    <nz-form-item class="floating-label" style="margin: 0px; flex: 1">
                        <nz-form-label [nzNoColon]="true">dx3</nz-form-label>
                        <nz-input-number nzSize="small" [nzMin]="0.01" [nzDisabled]="!jobState.variableDx()"
                            [ngModel]="toRangeUnit(jobState.dx3())" [ngModelOptions]="{ updateOn: 'blur' }"
                            (ngModelChange)="setDx('dx3', $event)" (keydown.enter)="$any($event.target).blur()" />
                    </nz-form-item>
                </div>
            </div>
        </li>
    </ul>
</nz-dropdown-menu>